<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "smiley-happy" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    viewBox = '0 0 100 100'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    fill = '#272711'
>
    <g>
        <!-- eslint-disable max-len -->
        <path vector-effect={isScaling ? 'none' : 'non-scaling-stroke'} d="M50 98C23.533 98 2 76.467 2 50S23.533 2 50 2s48 21.533 48 48-21.533 48-48 48zm0-90C26.841 8 8 26.841 8 50s18.841 42 42 42 42-18.841 42-42S73.159 8 50 8zm26.684 52.342a2.992 2.992 0 0 0-1.327-4.006 3.015 3.015 0 0 0-4.03 1.304C71.107 58.062 65.778 68 50 68c-15.74 0-21.081-9.889-21.325-10.356a2.992 2.992 0 0 0-4.017-1.327 3 3 0 0 0-1.342 4.025C23.596 60.9 30.371 74 50 74s26.404-13.1 26.684-13.658zM65 44c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zm-30 0c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z">
        </path>
    </g>
</svg>